import { useState } from 'react'
import './panneladmin.css'
import Newsdata from '../newsdata/Newsdata'
import Support from '../support/Support'
import Commentdata from '../commentdata/Commentdata'
import Coursedata from '../coursedata/Coursedata'
export default function Panneladmin() {
    const [openpanel, setOpenpanel] = useState(false)
    const [selectpage, setSelectpage] = useState('help')
    function openandclose() {
        openpanel ? setOpenpanel(false) : setOpenpanel(true)
    }
    function help() {
        setSelectpage('help')
    }
    function course() {
        setSelectpage('course')
    }
    function news() {
        setSelectpage('news')
    }
    function setting() {
        setSelectpage('comment')
    }
    function support() {
        setSelectpage('support')
    }
    return (
        <div className='pannelpage'>
            <div className='menubox' style={openpanel ? { left: '0%' } : { left: '-200px' }}>
                <button onClick={openandclose} style={openpanel ? { left: '200px' } : { left: '0%' }}>{openpanel ? 'بستن منو' : 'باز کردن منو'}</button>
                <div className='menulist'>
                    <ul>
                        <li onClick={help} style={{ backgroundColor: selectpage === 'help' ? '#801E48' : 'white', color: selectpage === 'help' ? 'white' : 'black' }}><p>راهنمایی</p></li>
                        <li onClick={course} style={{ backgroundColor: selectpage === 'course' ? '#801E48' : 'white', color: selectpage === 'course' ? 'white' : 'black' }}><p>دوره ها</p></li>
                        <li onClick={news} style={{ backgroundColor: selectpage === 'news' ? '#801E48' : 'white', color: selectpage === 'news' ? 'white' : 'black' }}><p>اخبار</p></li>
                        <li onClick={setting} style={{ backgroundColor: selectpage === 'comment' ? '#801E48' : 'white', color: selectpage === 'comment' ? 'white' : 'black' }}><p>نظرات</p></li>
                        <li onClick={support} style={{ backgroundColor: selectpage === 'support' ? '#801E48' : 'white', color: selectpage === 'support' ? 'white' : 'black' }}><p>پشتیبانی</p></li>
                    </ul>
                </div>
            </div>
            {selectpage === 'news' ? <Newsdata /> : selectpage === 'support' ? <Support /> : selectpage === 'comment' ? <Commentdata /> : selectpage === 'course' ? <Coursedata /> :
                <div className='panelinfo'>
                    <h3>به پنل ادمین خوش آمدید</h3>
                    <h2>آموزش</h2>
                    <p>جهت استفاده از پنل ادمینی روی دکمه باز کردن منو کلیک کنید تا از امکانات پنل استفاده کنید.</p>
                    <p>برای ارتباط با پشتیبانی سایت در منو پنل گزینه پشتیبانی کلیک کنید.</p>
                    <h2>قوانین</h2>
                    <p>از انتشار رمز پنل ادمین اکیدا خودداری فرمایید.</p>
                    <p>حذف یا ویرایش اطلاعات بدون هماهنگی ممنوع است.</p>
                    <p>جهت افزایش سرعت و بالا رفتن امنیت , زمان زیادی را در پنل نمانید.</p>
                    <p>استفاده از این پنل برای سایت های دیگر بدون هماهنگی با سازنده سایت ممنوع است.</p>
                    <p>جهت افزایش امنیت پنل از VPN استفاده نکنید.</p>
                </div>
            }
        </div>
    )
}